// import React from "react";
// import Automationone from "../components/Section/Steelpipeone";
// import Automationtwo from "../components/Section/Steelpipetwo";

// function Automation() {
//   return (
//     <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">
//       <Automationone />
//       <Automationtwo />
//     </div>
//   );
// }

// export default Automation;
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Structsteelone from "../components/Section/Steelpipeone";
import Structsteeltwo from "../components/Section/Steelpipetwo";

function Automation() {
  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 4000); // 3 seconds delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-[#0C2341] min-h-screen mx-4 mt-2 flex items-center justify-center">
      {showAnimation ? (
        // Spinning Circle Animation
        <div className="flex justify-center items-center min-h-[50vh]">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }}
            className="w-16 h-16 border-4 border-t-blue-500 border-b-transparent border-r-transparent border-l-blue-500 rounded-full"
          ></motion.div>
        </div>
      ) : (
        // Main Content (Animated Fade-in)
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="w-full"
        >
          <Structsteelone />
          <Structsteeltwo />
        </motion.div>
      )}
    </div>
  );
}

export default Automation;